import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import PromoBanner from './components/PromoBanner';
import HeroSection from './components/HeroSection';
import AasPillarsSection from './components/AasPillarsSection';
import ClinicalTrainingSection from './components/ClinicalTrainingSection';
import TrainingCenterSection from './components/TrainingCenterSection';
import AboutUsSection from './components/AboutUsSection';
import PhilosophySection from './components/PhilosophySection';
import WhatWeDoSection from './components/WhatWeDoSection';
import './LandingPage.css';

const LandingPage = () => {
  const navigate = useNavigate();

  const handleNavigate = useCallback(
    (url) => {
      if (!url) return;
      const isExternal = url.startsWith('http') || url.startsWith('pages/');
      if (isExternal) {
        window.location.assign(url);
        return;
      }
      navigate(url);
    },
    [navigate],
  );

  const handlePromoClick = useCallback(() => {
    handleNavigate('/courses');
  }, [handleNavigate]);

  return (
    <div className="landing-page">
      <PromoBanner
        message="NUEVO LANZAMIENTO - ¡Descubre nuestros nuevos cursos y formaciones!"
        linkText="HACÉ CLICK ACÁ"
        onLinkClick={handlePromoClick}
      />
      <HeroSection />
      <AasPillarsSection />
      <ClinicalTrainingSection />
      <TrainingCenterSection />
      <AboutUsSection />
      <PhilosophySection />
      <WhatWeDoSection />
    </div>
  );
};

export default LandingPage;
